import { useMaps } from "../stores/maps";
import { toRaw } from "vue";
import { useDrawingStore } from "../stores/drawing";
import { useSplitFieldStore } from "../stores/splitField";

class DeleteMenu {
    constructor(map) {
        this.map = map;
        this.div_ = document.createElement("div");
        this.div_.className = "delete-menu";
        this.div_.innerHTML = "Delete";
        
        // Button styles
        this.div_.style.position = "absolute";
        this.div_.style.backgroundColor = "#fff";
        this.div_.style.padding = "6px 12px";
        this.div_.style.border = "none";
        this.div_.style.borderRadius = "4px"; 
        this.div_.style.cursor = "pointer";
        this.div_.style.fontSize = "14px";
        this.div_.style.fontWeight = "500";
        this.div_.style.color = "#dc3545";
        this.div_.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
        this.div_.style.zIndex = "10000";
        this.div_.style.display = "none";
        this.div_.style.transition = "all 0.2s ease";
        this.div_.style.userSelect = "none";
        
        // Hover effect
        this.div_.onmouseover = () => {
            this.div_.style.backgroundColor = "#dc3545";
            this.div_.style.color = "#fff";
        };
        this.div_.onmouseout = () => {
            this.div_.style.backgroundColor = "#fff"; 
            this.div_.style.color = "#dc3545";
        };

        this.position = null;
        this.shapeInfo = null;
        
        // Click event listener
        this.div_.addEventListener("click", async () => {
            await this.removeVertex();
        });

        // Add div to map panes
        const panes = map.getDiv();
        panes.appendChild(this.div_);
        
        // Add listener for clicks outside menu only when menu is visible
        this.mapClickListener = null;
    }

    open(shapeInfo) {
        if (!shapeInfo || !shapeInfo.shape || shapeInfo.vertex === undefined) {
            console.error("Invalid shape info provided:", shapeInfo);
            return;
        }

        // Get all points coordinates
        const pathArray = shapeInfo.shape.getPath().getArray();

        // Filter same coordinates in pathArray
        const uniquePathArray = pathArray.filter((point, index, self) =>
            index === self.findIndex((t) => (
                t.lat() === point.lat() && t.lng() === point.lng()
            ))
        );

        // Don't allow deletion if less than 3 distinct points would remain
        if (uniquePathArray.length <= 3) {
            console.error("Shape has less than 3 distinct points:", shapeInfo);
            return;
        }

        const mapStore = useMaps();
        this.shapeInfo = shapeInfo;
        
        try {
            const path = shapeInfo.shape.getPath();
            if (!path || !path.getArray) {
                console.error("Invalid path object:", path);
                return;
            }

            const pathArray = path.getArray();
            if (!pathArray || shapeInfo.vertex >= pathArray.length) {
                console.error("Invalid path array or vertex index:", { pathArray, vertex: shapeInfo.vertex });
                return;
            }

            this.position = pathArray[shapeInfo.vertex];
            
            // Convert LatLng to pixel coordinates
            const projection = mapStore.map.getProjection();
            const bounds = mapStore.map.getBounds();
            const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
            const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
            const scale = Math.pow(2, mapStore.map.getZoom());
            const latLng = this.position;
            const point = projection.fromLatLngToPoint(latLng);
            const x = (point.x - bottomLeft.x) * scale;
            const y = (point.y - topRight.y) * scale;

            // Set menu position
            this.div_.style.left = Math.round(x) + "px";
            this.div_.style.top = Math.round(y) + "px";
            this.div_.style.display = "block";

            // Add click listener only when menu becomes visible
            if (!this.mapClickListener) {
                this.mapClickListener = this.map.addListener("mousedown", (e) => {
                    if (e.target !== this.div_) {
                        this.close();
                    }
                });
            }
        } catch (error) {
            console.error("Error in open method:", error);
            return;
        }
    }

    async removeVertex() {
        
        if (!this.shapeInfo || !this.shapeInfo.shape || !this.shapeInfo.shape.getPath) {
            this.close();
            return;
        }

        try {
            const path = this.shapeInfo.shape.getPath()
            
            // Don't allow deletion if less than 3 points would remain
            if (path.getLength() <= 3) {
                this.close()
                return
            }
            
            path.removeAt(toRaw(this.shapeInfo.vertex))

            // Update shape info
            this.shapeInfo.shape.setPath(path)

            // Only set isModified if the shape is not the split line from splitField store
            const sf = useSplitFieldStore()
            const ds = useDrawingStore()
            
            // Check if this shape is the split line from splitField store
            const isSplitLine = toRaw(sf.splitLine) === toRaw(this.shapeInfo.shape)
            
            if (!isSplitLine) {
                ds.isModified = true
            }

        } catch (error) {
            console.error("Error in removeVertex:", error)
        }

        this.close();
    }

    close() {
        this.div_.style.display = "none";
        this.position = null;
        this.shapeInfo = null;

        // Remove click listener when menu is closed
        if (this.mapClickListener) {
            this.mapClickListener.remove();
            this.mapClickListener = null;
        }
    }

    removeListener() {
        if (this.mapClickListener) {
            this.mapClickListener.remove();
            this.mapClickListener = null;
        }
        if (this.div_.parentNode) {
            this.div_.parentNode.removeChild(this.div_);
        }
    }
}

export default DeleteMenu;
